import http from 'utils/http';
import API_SY from 'utils/http/api/system';

// 용처 :: 용처증빙 파일 다운로드
export async function requestSystemPurposeAttachmentDownload(purposeOfLoanId: number) {
  await http.download(API_SY.PURPOSE_OF_LOANS.DOWNLOAD_PURPOSE_ATTACHMENT(purposeOfLoanId));
}

// 용처 :: 지급계좌 파일 다운로드
export async function requestSystemAccountAttachmentDownload(purposeOfLoanId: number) {
  await http.download(API_SY.PURPOSE_OF_LOANS.DOWNLOAD_ACCOUNT_ATTACHMENT(purposeOfLoanId));
}
